module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NTYuOTU0IiBoZWlnaHQ9IjYzNS4zNTkiIHZpZXdCb3g9IjAgMCA1NTYuOTU0IDYzNS4zNTkiPgogIDxwYXRoIGlkPSLjg5HjgrlfMzc0NiIgZGF0YS1uYW1lPSLjg5HjgrkgMzc0NiIgZD0iTTUxNy4yMzIsMTUwNC45VjEwODAuNjI5bDU1Ni45NTQtMjExLjA5M1YxMjkzLjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNSkiIGZpbGw9ImxpbWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/green_557.svg
// module id = PMa/
// module chunks = 0